import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

/**
 * Centralised error handler interceptor.
 * Handles 401 (session expired) and 403 (access denied) globally.
 * Retry logic lives in authInterceptor to avoid double retries.
 */
export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        // Session expired or token invalid — clear state and redirect once
        authService.logout();
      } else if (error.status === 403) {
        router.navigate(['/app/acesso-negado']);
      }
      return throwError(() => error);
    })
  );
};
